import { ChangeDetectionStrategy, Component, ComponentRef, ViewContainerRef, Input } from '@angular/core';
import { I18nModule, FeaturesConfigModule } from '@spartacus/core';
import { LAUNCH_CALLER, LaunchDialogService, IconModule } from '@spartacus/storefront';
import { combineLatest } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { GenProductImageZoomDialogComponent } from './product-image-zoom-dialog/product-image-zoom-dialog.component'
import { ProductImageZoomTriggerComponent } from '@spartacus/product/image-zoom/components';

@Component({
  selector: 'gen-product-image-zoom-trigger',
  templateUrl: './product-image-zoom-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IconModule, I18nModule, FeaturesConfigModule]
})
export class GenProductImageZoomTriggerComponent extends ProductImageZoomTriggerComponent {

  @Input() override galleryIndex: number;
  constructor(
     launchDialogService: LaunchDialogService,
     vcr: ViewContainerRef
  ) {
    super(launchDialogService, vcr)
  }

  override triggerZoom(): void {
   const component = this.launchDialogService.launch(
      LAUNCH_CALLER.PRODUCT_IMAGE_ZOOM,
      this.vcr
    );
    if (component) {
      this.subscriptions.add(
        combineLatest([component, this.launchDialogService.dialogClose])
          .pipe(
            tap(([comp]) => {
              if (this.galleryIndex) {
                (
                  comp as ComponentRef<GenProductImageZoomDialogComponent>
                ).instance.galleryIndex = this.galleryIndex;
              }
            }),
            filter(([, close]) => Boolean(close)),
            tap(([comp]) => {
              this.launchDialogService.clear(LAUNCH_CALLER.PRODUCT_IMAGE_ZOOM);
              comp?.destroy();
              this.dialogClose.emit();
              this.expandButton.nativeElement.focus();
            })
          )
          .subscribe()
      );
    }
  }
}